/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { DataTableHeader } from '../../../../data-table/DataTableHeader';
import { ChartData } from '../../../charts/models/ChartData';

@Component({
  selector: 'app-ctv-inventory',
  templateUrl: './ctv-inventory.component.html',
  styleUrls: ['./ctv-inventory.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvInventoryComponent implements OnInit, OnChanges {
  headers: Array<DataTableHeader>;
  regionHeaders: Array<DataTableHeader>;
  adSizeHeaders: Array<DataTableHeader>;
  dmaHeaders: Array<DataTableHeader>;
  topRegion: any;
  topAdSize: any;
  topDma: any;
  lineChartData: Array<ChartData>;
  @Input() data: any;
  @Input() isFreemium: boolean;

  ngOnInit(): void {
    this.headers = [];
    this.headers.push({
      class: 'col-3',
      text: 'Device',
      key: 'deviceMarketingName',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col-2 text-xs-right',
      text: 'Est. Inventory',
      key: 'totalInventoryRatio',
      tooltipkey: '',
      format: 'percent'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'Est. IVT',
      key: 'givtSivtRate',
      tooltipkey: '',
      format: 'percent'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'Video',
      key: 'videoImpressionsRatio',
      tooltipkey: '',
      format: 'percent'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: 'Display',
      key: 'displayImpressionsRatio',
      tooltipkey: '',
      format: 'percent'
    });

    this.regionHeaders = [];
    this.regionHeaders.push({
      class: 'col-3',
      text: 'Region',
      key: 'countryCode',
      tooltipkey: ''
    });
    this.regionHeaders.push({
      class: 'col-2 text-xs-right',
      text: 'Est. Inventory',
      key: 'totalInventoryRatio',
      tooltipkey: '',
      format: 'percent'
    });
    this.regionHeaders.push({
      class: 'col text-xs-right',
      text: 'Est. IVT',
      key: 'givtSivtRate',
      tooltipkey: '',
      format: 'percent',
      lockedInFreemium: this.isFreemium
    });
    this.regionHeaders.push({
      class: 'col text-xs-right',
      text: 'Est. SSAI',
      key: 'nonGivtSivtSsaiImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });
    this.regionHeaders.push({
      class: 'col-3 text-xs-right',
      text: 'Est. Transparent SSAI',
      key: 'nonGivtSivtSsaiTransparentImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });

    this.adSizeHeaders = [];
    this.adSizeHeaders.push({
      class: 'col-3',
      text: 'Ad Size',
      key: 'adSize',
      tooltipkey: ''
    });
    this.adSizeHeaders.push({
      class: 'col-2 text-xs-right',
      text: 'Est. Inventory',
      key: 'totalInventoryRatio',
      tooltipkey: '',
      format: 'percent'
    });
    this.adSizeHeaders.push({
      class: 'col text-xs-right',
      text: 'Est. IVT',
      key: 'givtSivtRate',
      tooltipkey: '',
      format: 'percent',
      lockedInFreemium: this.isFreemium
    });
    this.adSizeHeaders.push({
      class: 'col text-xs-right',
      text: 'Est. SSAI',
      key: 'nonGivtSivtSsaiImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });
    this.adSizeHeaders.push({
      class: 'col-3 text-xs-right',
      text: 'Est. Transparent SSAI',
      key: 'nonGivtSivtSsaiTransparentImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });

    this.dmaHeaders = [];
    this.dmaHeaders.push({
      class: 'col-3',
      text: 'DMA',
      key: 'dmaName',
      tooltipkey: ''
    });
    this.dmaHeaders.push({
      class: 'col-2 text-xs-right',
      text: 'Est. Inventory',
      key: 'totalInventoryRatio',
      tooltipkey: '',
      format: 'percent'
    });
    this.dmaHeaders.push({
      class: 'col text-xs-right',
      text: 'Est. IVT',
      key: 'givtSivtRate',
      tooltipkey: '',
      format: 'percent',
      lockedInFreemium: this.isFreemium
    });
    this.dmaHeaders.push({
      class: 'col text-xs-right',
      text: 'Est. SSAI',
      key: 'nonGivtSivtSsaiImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });
    this.dmaHeaders.push({
      class: 'col-3 text-xs-right',
      text: 'Est. Transparent SSAI',
      key: 'nonGivtSivtSsaiTransparentImpressionsRate',
      tooltipkey: '',
      format: 'percent'
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.topRegion =
        this.data.regionDistribution && this.data.regionDistribution[0]
          ? this.data.regionDistribution[0]
          : null;
      this.topAdSize =
        this.data.adSizeDistribution && this.data.adSizeDistribution[0]
          ? this.data.adSizeDistribution[0]
          : null;

      this.topDma =
        this.data.dmaDistribution && this.data.dmaDistribution[0]
          ? this.data.dmaDistribution[0]
          : null;

      if (this?.data?.user?.byMonth) {
        this.lineChartData = this?.data?.user?.byMonth;
        this.lineChartData.reverse();
      }
    }
  }
}
